const isFalsy = value => !value;

// noinspection JSUnusedGlobalSymbols
export default isFalsy;
